'use client'

import { GlobeIcon } from '@radix-ui/react-icons'
import { useTranslations } from 'next-intl'

import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { useToast } from '@/components/ui/use-toast'

import { incomingLocale, switchLocale } from '@/hooks/locale-switcher'
interface GlobalLangSwitcherProps {
  isAuthenthicated: boolean
}

// @TODO: add vi support
// <DropdownMenuItem
// onClick={() => {
//   triggerSwitchLocale('vi')
// }}
// >
// {t('vi')}
// </DropdownMenuItem>
export const GlobalLangSwitcher = ({ isAuthenthicated }: GlobalLangSwitcherProps) => {
  const t = useTranslations('Common.LocaleSwitcher')
  const tCommon = useTranslations('Common')
  const { toast } = useToast()

  const triggerSwitchLocale = async (locale: incomingLocale) => {
    const { ok } = await switchLocale(locale, isAuthenthicated)
    if (!ok) toast({ variant: 'destructive', description: tCommon('Components.languageUpdateFailed') })
    window.location.reload()
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <GlobeIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => {
            triggerSwitchLocale('en')
          }}
        >
          {t('en')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            triggerSwitchLocale('ja')
          }}
        >
          {t('ja')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
